import { Box, Button, Typography } from "@mui/material";

interface FileUploadFieldProps {
  label: string;
  file: File | null;
  onChange: (file: File | null) => void;
  error?: string;
}

const FileUploadField = ({ label, file, onChange, error }: FileUploadFieldProps) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Button variant="contained" component="label" fullWidth>
        {label}
        <input
          type="file"
          hidden
          onChange={(e) => onChange(e.target.files?.[0] || null)}
        />
      </Button>
      {error && (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      )}
      {file && (
        <Typography variant="caption" display="block">
          {file.name}
        </Typography>
      )}
    </Box>
  );
};

export default FileUploadField;

